const MOBILE_MAX_WIDTH = 500;

/**
 * @param {number} windowWidth - the width of the window
 * @returns {boolean} indicates if the window is the size of a mobile screen
 */
export const isMobileScreen = (windowWidth) => windowWidth <= MOBILE_MAX_WIDTH;
